module.exports = __webpack_public_path__ + "inner-accordion@2x.jpg?78817651e460d3bec3789c7083a26529";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inner-accordion@2x.jpg
// module id = 215
// module chunks = 0